/**
 * Enostos — Blog Post Custom JS (v3)
 *
 * Parallax strategy:
 *
 * Desktop (no-touch):
 *   background-attachment:fixed on the .eno-parallax-figure__bg div.
 *   Native CSS, zero JS cost on scroll.
 *
 * Mobile / iOS Safari:
 *   background-attachment:fixed is broken inside overflow:hidden on
 *   WebKit. Instead we use the "portal" technique:
 *     - .eno-parallax-figure__bg is moved to <body> as a direct child
 *     - It gets position:fixed, sized to the viewport
 *     - On every scroll tick we read the figure's bounding rect and
 *       use clip-path to reveal only the portion that overlaps the
 *       figure's visible window
 *     - This gives a true parallax effect: the image stays fixed,
 *       the content scrolls over it
 */

(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────── */

  function getBestSrc(img) {
    var srcset = img.getAttribute('srcset') || '';
    if (srcset) {
      var candidates = srcset.split(',').map(function(s) {
        var parts = s.trim().split(/\s+/);
        return { url: parts[0], w: parseInt(parts[1]) || 0 };
      });
      candidates.sort(function(a, b) { return b.w - a.w; });
      if (candidates[0] && candidates[0].url) {
        return candidates[0].url.replace(/([?&]width=)\d+/, '$12560');
      }
    }
    return (img.getAttribute('src') || '').replace(/([?&]width=)\d+/, '$12560');
  }

  /**
   * Build a parallax figure.
   *
   * Strategy: pure CSS, no scroll listeners, works on all devices.
   *
   * The figure is a clipping window (overflow:hidden).
   * Inside it, the bg div is position:sticky so it stays visible
   * as you scroll through the figure — creating a parallax window
   * effect natively handled by the browser.
   *
   * On desktop we additionally use background-attachment:fixed
   * for a stronger parallax effect. On mobile, sticky is enough
   * and is perfectly stable.
   */
  function buildParallaxFigure(src, alt) {
    var figure = document.createElement('figure');
    figure.className = 'eno-parallax-figure';
    if (alt) figure.setAttribute('aria-label', alt);

    var bg = document.createElement('div');
    bg.className = 'eno-parallax-figure__bg';
    bg.style.backgroundImage = "url('" + src + "')";

    figure.appendChild(bg);
    return figure;
  }

  /* ── Main DOM processing ─────────────────────────────── */

  function processImages() {

    var featuredImageBlock = document.querySelector('[id*="blog-post-image"]');
    var contentBlock       = document.querySelector('[id*="blog-post-content"]');

    var rteFormatter = contentBlock && contentBlock.querySelector('rte-formatter');
    var rte = rteFormatter || (contentBlock && contentBlock.querySelector('.rte'));

    if (!rte) return false;

    var paragraphs = Array.from(rte.querySelectorAll('p')).filter(function(p) {
      return p.textContent.trim().length > 20;
    });

    if (paragraphs.length === 0) return false;

    // ── 1. In-content images ──────────────────────────────────────────

    var imgs = Array.from(rte.querySelectorAll('img')).filter(function(img) {
      return !img.closest('.eno-parallax-figure');
    });

    imgs.forEach(function(img) {
      var src = getBestSrc(img);
      if (!src) return;

      var figure = buildParallaxFigure(src, img.alt || '');
      var parent = img.parentElement;
      var isLonelyInP =
        parent &&
        parent.tagName === 'P' &&
        parent.innerHTML.replace(/<img[^>]*>/gi, '').trim() === '';

      if (isLonelyInP) {
        parent.replaceWith(figure);
      } else {
        img.insertAdjacentElement('beforebegin', figure);
        img.style.display = 'none';
      }
    });

    // ── 2. Featured image ─────────────────────────────────────────────

    if (featuredImageBlock) {
      var featuredImg = featuredImageBlock.querySelector('img');
      if (featuredImg) {
        var src = getBestSrc(featuredImg);
        var figure = buildParallaxFigure(src, featuredImg.alt || '');

        featuredImageBlock.style.display = 'none';
        paragraphs[0].insertAdjacentElement('afterend', figure);
      }
    }

    // ── 3. Fix overflow on ancestor containers ────────────────────────

    var section = document.querySelector('.section-content-wrapper');
    if (section) {
      var el = section;
      for (var i = 0; i < 8; i++) {
        if (!el || el === document.body) break;
        var computed = window.getComputedStyle(el);
        if (computed.overflow === 'hidden' || computed.overflowX === 'hidden') {
          el.style.overflow = 'visible';
        }
        el = el.parentElement;
      }
    }

    return true;
  }

  /* ── Init with rte-formatter retry ──────────────────── */

  function init() {
    var attempts = 0;
    var maxAttempts = 60;

    function attempt() {
      attempts++;
      var done = processImages();
      if (!done && attempts < maxAttempts) {
        requestAnimationFrame(attempt);
      }
    }

    requestAnimationFrame(attempt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();